import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/vee-validate/fr";

import Notifications from "vue-notification";

// Filters
import "./filters/filters";

Vue.config.productionTip = false;

Vue.use(Notifications);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
